import {reAuthenticateInModal} from '@Libraries/social-media-account.library';
import type {ComponentAction, ComponentActionDoneHandler, ComponentActionSession, ComponentActionTarget} from './component-action.types';
import {ComponentActionType} from './component-action.types';
import {getTargetPlatform, listenForSocialAccountConnections} from './social-account-action.library';

const openReconnectSession = (onDone: ComponentActionDoneHandler): ComponentActionSession => {
  const listener = listenForSocialAccountConnections(onDone);

  return {
    start: (target: ComponentActionTarget): void => {
      const idAccount = target.actionData?.accountId;
      const platform = getTargetPlatform(target);
      if (typeof idAccount !== 'number' || !Number.isInteger(idAccount) || platform === null) {
        return;
      }

      listener.recordStart(target, platform);
      reAuthenticateInModal(idAccount, platform);
    },
    close: listener.close,
  };
};

export const reconnectSocialAccountAction: ComponentAction = {
  actionType: ComponentActionType.RECONNECT_SOCIAL_ACCOUNT,
  openSession: openReconnectSession,
  resumePromptFor: (target): string => window.i18next.t('pmwjs_ai_chat_social_account_reconnected', {accountName: target.label, platformName: target.meta ?? ''}),
  doneLabelKey: 'pmwjs_ai_chat_social_account_reconnected_status',
};
